/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiScenarioEntityType,
    ApiScenarioEntityTypeFromJSON,
    ApiScenarioEntityTypeToJSON,
    ApiScenarioReason,
    ApiScenarioReasonFromJSON,
    ApiScenarioReasonToJSON,
} from '../models';

export interface FindAllScenarioReasonsRequest {
    entityType?: ApiScenarioEntityType;
}

export interface FindAllScenarioReasonsV2Request {
    entityType: ApiScenarioEntityType;
}

/**
 * 
 */
export class ScenarioApi extends runtime.BaseAPI {

    /**
     * Fetches all scenario reasons
     */
    async findAllScenarioReasonsRaw(requestParameters: FindAllScenarioReasonsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/reasons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches all scenario reasons
     */
    async findAllScenarioReasons(requestParameters: FindAllScenarioReasonsRequest = {}, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.findAllScenarioReasonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all scenario reasons and returns associated scenario identifiers.
     */
    async findAllScenarioReasonsV2Raw(requestParameters: FindAllScenarioReasonsV2Request, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScenarioReason>>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling findAllScenarioReasonsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/reasons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScenarioReasonFromJSON));
    }

    /**
     * Fetches all scenario reasons and returns associated scenario identifiers.
     */
    async findAllScenarioReasonsV2(requestParameters: FindAllScenarioReasonsV2Request, initOverrides?: RequestInit): Promise<Array<ApiScenarioReason>> {
        const response = await this.findAllScenarioReasonsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
